import type { Currency } from '@zep/types';

enum PaypleServiceId {
  USD = 'zepbill',
  JPY = 'zepbill1',
  TEST_JPY = 'zeptestjpy',
  TEST_USD = 'zeptestusd',
}

export const getChargeZemPaypleServiceId = ({
  currency,
  isTest,
}: {
  currency: Currency;
  isTest: boolean;
}) => {
  if (currency === 'JPY') {
    return isTest ? PaypleServiceId.TEST_JPY : PaypleServiceId.JPY;
  }

  return isTest ? PaypleServiceId.TEST_USD : PaypleServiceId.USD;
};

export const getDefaultPaypleServiceId = ({ isTest }: { isTest: boolean }) => {
  return isTest ? PaypleServiceId.TEST_USD : PaypleServiceId.USD;
};
